
export const setFccMasterRegistryMutator = async (state, payload) => {
  state.fccMasterRegistry = payload
}
